import { StyleRules, BadgeClassKey } from '@material-ui/core';

export const MuiBadge: Partial<StyleRules<BadgeClassKey, {}>> = {
  badge: {
    fontWeight: 900,
  },
};
